import React from "react";

const ReusableModal = ({ title, content, ButtonValue, onClose, onUpload }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-[20px] shadow-lg max-w-md w-full max-h-[90vh] flex flex-col">
        <div className="p-8 pb-4">
          <h2 className="text-lg font-bold mb-2">{title}</h2>
        </div>
        
        <div className="px-8 overflow-y-auto flex-1">
          <div className="mb-4">{content}</div>
        </div>

        <div className="p-8 pt-4">
          <div className="flex gap-2 w-full justify-center">
            <button
              onClick={onClose}
              className="border-[1.5px] border-[#035C98] text-gray-700 w-full py-2 rounded-[15px] hover:bg-gray-100 cursor-pointer"
            >
              Cancel
            </button>
            <button
              onClick={() => (onUpload ? onUpload() : () => {})}
              className="border bg-[#035C98] text-white w-full py-2 rounded-[15px] cursor-pointer"
            >
              {ButtonValue}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReusableModal;
